/**
 * PATH: apps/billing/src/pages/PaymentSchedulePage.tsx
 * FILE_ID: BILLING-PAGE-SCHEDULE-001
 * PURPOSE: Mount the shared <PaymentSchedule/> at /payment_schedule.
 *
 * WHY: Bookkeepers asked for a "Cash Out / Payment Schedule" view
 *      so they can see what's overdue and what's due this week
 *      without leaving the Billing Hub. Reuses the same component
 *      as SAM (`apps/sam/src/features/bills/pages/BillingSchedulePage.tsx`)
 *      to keep AP triage consistent across hubs.
 *
 *      Clicking a row deep-links into /book_keeping?id=<billId>
 *      so the existing 3-pane workspace handles editing/approval.
 */

import { useNavigate } from 'react-router-dom';
import { PaymentSchedule } from '@quotech/bills';

export default function PaymentSchedulePage() {
  const navigate = useNavigate();
  return (
    <div className="h-full w-full">
      <PaymentSchedule
        onSelectBill={(billId) => {
          navigate(`/book_keeping?id=${encodeURIComponent(billId)}`);
        }}
      />
    </div>
  );
}
